import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-cancelar-firma',
  templateUrl: './cancelar-firma.component.html',
  styleUrls: ['./cancelar-firma.component.css']
})
export class CancelarFirmaComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CancelarFirmaComponent>) { }

  ngOnInit(): void {
  }

}
